/** @format */

import React from 'react';

const ContactIcon = (): JSX.Element => {
  return (
    <>
      <svg width="56px" height="56px" viewBox="0 0 56 56">
        <g
          id="contact-icon"
          stroke="#000000"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round">
          <rect
            id="Rectangle"
            stroke="#000000"
            strokeWidth="2"
            x="7"
            y="14"
            width="42"
            height="27"></rect>
          <path
            d="M3,41 L53,41"
            id="Line"
            stroke="#000000"
            strokeWidth="2"></path>
          <g
            id="Group"
            transform="translate(16.000000, 18.000000)"
            stroke="#00A9E0">
            <path
              d="M7.5,0 C5.58490566,0 4,1.6 4,3.53333333 C4,5.46666667 5.58490566,7 7.5,7 C9.41509434,7 11,5.4 11,3.46666667 C11,1.53333333 9.41509434,0 7.5,0 Z"
              id="Path"></path>
            <path
              d="M14,18 L14,15.2830725 C14,11.2442778 10.8181818,8 7,8 C3.18181818,8 0,11.2442778 0,15.2830725 L0,18"
              id="Path"></path>
          </g>
          <path
            d="M35.4647887,22 C34.056338,22 33,23.1428571 33,24.5 C33,25.8571429 34.1267606,27 35.4647887,27 C36.8028169,27 38,25.9285714 38,24.5714286 C38,23.2142857 36.8732394,22 35.4647887,22 Z"
            id="Path"
            stroke="#000000"></path>
          <path
            d="M41,34 C41,34 41,34 41,34 C41,30.7209302 38.5163399,28 35.379085,28 C33.6143791,28 31.9803922,28.9069767 31,30.3023256"
            id="Path"
            stroke="#000000"></path>
        </g>
      </svg>
    </>
  );
};
export default ContactIcon;
